import AiAnalysisFeedbacksService from "@/api/services/aiAnalysisFeedbacks";

export default {
  namespaced: true,

  actions: {
    async submitFeedback(_, { analysableType, analysableId, analysisType, comment }) {
      return AiAnalysisFeedbacksService.createFeedback({
        analysableType,
        analysableId,
        analysisType,
        comment,
      });
    },
  },
};
